export const points = [
  {
    name: "Up to 3x Allo Points from [usd.ai](https://usd.ai) pro-rata based on allocation.",
    logo: "/points/allo.png",
    collateralVaults: ["0xe4783824593a50Bfe9dc873204CEc171ebC62dE0"],
  },
  {
    name: "15x Allo Points from [usd.ai](https://usd.ai) pro-rata based on allocation.",
    logo: "/points/allo.png",
    collateralVaults: ["0xFe3320fD1baCf38Bf74B84eF0ef7b34562926DDf"],
  },
  {
    name: "3x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: [
      "0x6aFB8d3F6D4A34e9cB2f217317f4dc8e05Aa673b",
      "0x482C3E2530FAc8FE2c63AE007AD2695C6d685E98",
      "0x683B777A393BA94F3c903fba2b14A6b6fF80dbE7",
    ],
  },
  {
    name: "2x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: ["0xAABb9cbAC15a3D646dCdc6574bCFCfB989E1fDd8"],
  },
  {
    name: "5x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: ["0x7D9790403FA53eF3E3a3389c259D244BDc61B785"],
  },
  {
    name: "0.1x Theo Points",
    logo: "/points/theo.svg",
    collateralVaults: [
      "0x44C10DA836d2aBe881b77bbB0b3DCE5f85C0C1Cc",
      "0xEE074ceB44adA094391B9C71A7Fb8ba6962D492c",
    ],
  },
  {
    name: "1x Theo Points",
    logo: "/points/theo.svg",
    collateralVaults: ["0x79e1F4a1Cde92568D58EB823f81D9c0C7C384e6b"],
  },
] as const
